import api from "@/services/api";

const state = {
  assets: [],
};

const mutations = {
  SET_ASSETS(state, assets) {
    state.assets = assets;
  },
};

const actions = {
  async getAssets({ commit }) {
    try {
      const res = await api.get("/fixed-assets");
      commit("SET_ASSETS", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching fixed assets:", error.message);
      throw error;
    }
  },

  async createAsset({ dispatch }, assetData) {
    try {
      const result = await api.post("/fixed-assets", assetData);
      await dispatch("getAssets");
      return result.data;
    } catch (error) {
      console.error("Error creating fixed asset:", error.message);
      throw error;
    }
  },

  async updateAsset({ dispatch }, { id, assetData }) {
    try {
      const result = await api.put(`/fixed-assets/${id}`, assetData);
      await dispatch("getAssets");
      return result.data;
    } catch (error) {
      console.error("Error updating fixed asset:", error.message);
      throw error;
    }
  },

  async disposeAsset({ dispatch }, id) {
    try {
      const result = await api.put(`/fixed-assets/${id}/dispose`);
      await dispatch("getAssets");
      return result.data;
    } catch (error) {
      console.error("Error disposing fixed asset:", error.message);
      throw error;
    }
  },

  async runDepreciation({ dispatch }, payload = {}) {
    try {
      const result = await api.post("/fixed-assets/run-depreciation", payload);
      await dispatch("getAssets");
      return result.data;
    } catch (error) {
      console.error("Error running depreciation:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
